import {
  ArrowDownToLine,
  BarChart3,
  Briefcase,
  Calendar,
  Check,
  CheckCircle,
  ClipboardList,
  CloudOff,
  Euro,
  FileText,
  Gauge,
  Globe,
  Handshake,
  Hash,
  Layers,
  Link,
  RefreshCw,
  TrendingUp,
  User,
  Upload,
  Users,
  type LucideIcon,
} from "lucide-react";

/**
 * Icon map for schema-driven components.
 * Maps icon name strings from backend schema to Lucide icon components.
 */
export const ICON_MAP: Record<string, LucideIcon> = {
  hash: Hash,
  check: Check,
  link: Link,
  calendar: Calendar,
  campaign: Layers,
  "arrow-up": TrendingUp,
  sync: RefreshCw,
  gauge: Gauge,
  handshake: Handshake,
  "arrow-down-to-line": ArrowDownToLine,
  "cloud-off": CloudOff,
  globe: Globe,
  briefcase: Briefcase,
  users: Users,
  "file-text": FileText,
  upload: Upload,
  "check-circle": CheckCircle,
  euro: Euro,
  person: User,
  apply: ClipboardList,
  "bar-chart": BarChart3,
};

/**
 * Get an icon component by name (case-insensitive).
 */
export function getIcon(iconName: string | undefined): LucideIcon | null {
  if (!iconName) return null;
  return ICON_MAP[iconName.toLowerCase()] ?? null;
}
